/* global Dida */

export function addStat(statStr, userCid, envir, ad_position) {
  try {
    window.myTrack.addStat(statStr, {
      app_name: '乘车卡',
      tagName: 'body',
      name: statStr,
      envir,
      ad_position
    })
  } catch (e) {
    console.error('addStat', e)
  }
}
